import React from "react"
import { nanoid } from "nanoid"

function Ingredients({ ingredients }) {
    return (
        <>
            <h3>Ingredients</h3>
            <section className="container ingredientContainer">
                { ingredients.map( ingredient => {
                    return (
                        ingredient.image &&
                        <section key={nanoid()} className="tile ingredientTile">
                            <img 
                                src={`https://spoonacular.com/cdn/ingredients_500x500/${ingredient.image}`} 
                                alt="Ingredients" />
                            <div>
                                <p>{ingredient.nameClean}</p>
                                <span>{ingredient.amount.toFixed(1)} {ingredient.unit}</span>
                            </div>
                        </section>
                    )
                })}
            </section>
        </>
    )
}

export default Ingredients
